import { getAccessToken } from 'common/utils/auth/accessToken';

export const getAuthData = () => ({ access_token: getAccessToken() ? `Bearer ${getAccessToken()}` : '' });
